import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';
import querystring from 'querystring';

import axiosClient from 'utils/client';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';

const initialState = {
  metadata: {},
  data: {},
  isLoadingMetadata: false,
  isLoadingData: false,
  isError: false,
  isFilterUpdated: false,
};

const LMS_BASE_URL = () => getConfig().LMS_BASE_URL;

const additionalLearningAPI = {
  async fetchMetadata({ club }: any) {
    const params = { club };
    let qs = querystring.stringify(params);
    if (qs) {
      qs = `?${qs}`;
    }

    const result = await axiosClient({
      url: `${LMS_BASE_URL()}/api/bcm/additional/learning/metadata/${qs}`,
      method: 'GET',
    });
    return result;
  },

  async fetchAdditionalLearning({ club, page = 1, search }: any) {
    const params = {
      ...(club && { club }),
      ...(search && { search }),
      page,
    };

    let qs = querystring.stringify(params);
    if (qs) {
      qs = `?${qs}`;
    }

    const result = await axiosClient({
      url: `${LMS_BASE_URL()}/api/bcm/additional/learning/${qs}`,
      method: 'GET',
    });
    return result;
  },
};

export const getAdditionalLearningMetadata = createAsyncThunk(
  'additionalLearning/getMetadata',
  async (props: any) => {
    const response = await additionalLearningAPI.fetchMetadata(props);
    return response.data;
  },
);

export const getAdditionalLearning = createAsyncThunk(
  'additionalLearning/getData',
  async (props: any) => {
    const response = await additionalLearningAPI.fetchAdditionalLearning(props);
    return response.data;
  },
);

const slice = createSlice({
  name: 'additionalLearning',
  initialState: initialState,
  reducers: {
    updateFilters: (state: any) => {
      return {
        ...state,
        isFilterUpdated: true,
      };
    },
    resetAdditionalLearning: () => {
      return initialState;
    },
  },
  extraReducers: builder => {
    builder
      // Metadata cases
      .addCase(getAdditionalLearningMetadata.fulfilled, (state, action) => {
        return {
          ...state,
          metadata: action.payload,
          isLoadingMetadata: false,
          isError: false,
        };
      })
      .addCase(getAdditionalLearningMetadata.pending, state => {
        state.isLoadingMetadata = true;
      })
      .addCase(getAdditionalLearningMetadata.rejected, state => {
        state.isError = true;
        state.isLoadingMetadata = false;
      })
      // Data cases
      .addCase(getAdditionalLearning.fulfilled, (state, action) => {
        const { resetInitialState } = action.meta.arg;

        if (resetInitialState) {
          return {
            ...state,
            data: action.payload,
            isLoadingData: false,
            isError: false,
            isFilterUpdated: false,
          };
        }

        return {
          ...state,
          data: {
            next: get(action, 'payload.next', null),
            count: get(action, 'payload.count', 0),
            results: [
              ...get(state, `data.results`, []),
              ...get(action, 'payload.results', []),
            ],
          },
          isLoadingData: false,
          isError: false,
          isFilterUpdated: false,
        };
      })
      .addCase(getAdditionalLearning.pending, state => {
        state.isLoadingData = true;
      })
      .addCase(getAdditionalLearning.rejected, state => {
        state.isError = true;
        state.isLoadingData = false;
        state.isFilterUpdated = false;
      });
  },
});

export const { updateFilters, resetAdditionalLearning } = slice.actions;

export default slice.reducer;
